import { SimplePreloaderComponent } from "appworks/components/preloader/simple-preloader-component";

export class AgsPreloaderComponent extends SimplePreloaderComponent {
    protected update(): void {
        super.update();
        gameWrapper.loadProgressUpdate(Math.floor(super.getActualPercentage() * 100));
    }
}
